/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Seller_Phone_LabelInputs */

const en_checkout_seller_phone_label = /** @type {(inputs: Checkout_Seller_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Checkout_Seller_Phone_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_seller_phone_label = /** @type {((inputs?: Checkout_Seller_Phone_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Seller_Phone_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_seller_phone_label(inputs)
});